// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.InputByDataType.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import './Izenda.InputByDataTypeRegistration';

import React, { Component, PropTypes } from 'react';
import { observer } from 'mobx-react';
import editorFactories from 'share/factories/Izenda.PropertiesFieldEditorFactories';
import { getOr, concat, has, omit, isNil, invokeArgs, isNaN } from 'lodash/fp';

@observer
export default class InputByDataType extends Component {
  static propTypes = {
    type: PropTypes.string,
    onChange: PropTypes.func,
    beforeOnChange: PropTypes.func
  };

  shouldComponentUpdate(nextProps: Object) {
    let shouldUpdate;
    try {
      shouldUpdate = JSON.stringify(nextProps) !== JSON.stringify(this.props);
    } catch (e) {
      shouldUpdate = true;
    }

    return shouldUpdate;
  }

  onChangePopup = (data: Object) => {
    return this.onChange(getOr(data, 'value', data));
  };

  onChange = (newVal: Object, arg: Object) => {
    const props = this.props;
    const { beforeOnChange } = props;
    let newArgs = concat({ value: isNaN(newVal) ? null : newVal }, arg);

    const applyOnChange = function(updateParam) {
      newArgs = updateParam || newArgs;
      return Promise.resolve(invokeArgs('onChange', newArgs, props));
    }.bind(this);

    if (beforeOnChange) {
      return beforeOnChange.apply(this, newArgs).then(applyOnChange);
    }
    return applyOnChange();
  };

  render() {
    const props = this.props;
    const { type } = props;
    const hasValidation = has('validations', props);
    let rest = omit(
      [
        'className',
        'onChange',
        'beforeOnChange',
        'type',
        'keyPath',
        'validation',
        'groupByDateTime',
        'hiddenByState',
        !hasValidation ? 'field' : ''
      ],
      props
    );

    //!hasValidation && (rest = omit('field', rest));

    if (!type) {
      return null;
    }

    const editProps = Object.assign(omit(['onChange', 'beforeOnChange'], props), {
      onChange: this.onChange.bind(this),
      onChangePopup: this.onChangePopup.bind(this)
    });

    let control = editorFactories.create(type, editProps) || {
      component: <span>Not support [{type}] control</span>
    };

    const newProps = Object.assign(control.props || {}, rest);
    return <control.component {...newProps}>{isNil(control.child) ? null : control.child}</control.component>;
  }
}



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.InputByDataType.js